import { Button, Flex, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UTCNoShiftDatePicker } from 'src/components/v2/DatePicker';
import { buildUTCDateFromParts } from 'src/components/v2/DatePicker/UTCNoShiftDatePicker';
import { EmployeeSelect } from 'src/components/v2/Select';
import { ILeaveTicket } from 'src/types/hr_ticket/leaveTicket.type';
import { IResignationTicket } from 'src/types/hr_ticket/resignationTicket.type';
const { Text } = Typography;

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddNote: (note: string, resignDate?: Date, replacerId?: number) => void;
  resignationTicket?: IResignationTicket;
  leaveTicket?: ILeaveTicket;
}

export default function AddApproveNote({ open, setOpen, handleAddNote, resignationTicket, leaveTicket }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (resignationTicket) {
      form.setFieldsValue({
        resignDate: resignationTicket?.resignDate
          ? buildUTCDateFromParts(dayjs(resignationTicket.resignDate))
          : undefined
      });
      return;
    }
    if (leaveTicket) {
      form.setFieldsValue({
        replacerId: String(leaveTicket?.replacerId)
      });

      return;
    }
  }, [resignationTicket, leaveTicket, form]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((value) => {
        const params: any = {};
        params.note = value.note || '';
        if (resignationTicket) {
          params.resignDate = value.resignDate;
        } else if (leaveTicket) {
          params.replacerId = value.replacerId ? Number(value.replacerId) : undefined;
        }
        handleAddNote(params.note, params.resignDate, params.replacerId);
        setOpen(false);
        form.resetFields();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Xác nhận phê duyệt</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form layout='vertical' form={form}>
        {resignationTicket && (
          <Form.Item
            label='Ngày thôi việc'
            name='resignDate'
            trigger='onChangeUTC'
            getValueFromEvent={(date: Date) => date}
            getValueProps={(value) => ({
              value: value ? dayjs(value) : null
            })}
          >
            <UTCNoShiftDatePicker style={{ width: '100%' }} />
          </Form.Item>
        )}

        {leaveTicket && (
          <Form.Item label='Người thay thế' name='replacerId' rules={[{ required: true, message: '' }]}>
            <EmployeeSelect
              exclusionEmployee={leaveTicket?.leaveTicketDetails?.[0]?.employeeId}
              departmentId={leaveTicket?.leaveTicketDetails?.[0]?.employee?.departmentId}
            />
          </Form.Item>
        )}
        <Form.Item label='Ghi chú' name='note'>
          <TextArea rows={4} placeholder='Nhập ghi chú (Nếu có)' />
        </Form.Item>
      </Form>
    </Modal>
  );
}
